import { REQUEST_SALES, RECEIVE_SALES } from '../lib/actions';
import {
  SALES,
  SALES_PAGINATION,
  SALES_STATISTIC
} from '../lib/storageVariables';
import { getLocalStorage, setLocalStorage } from '../lib/functions';

const STATE = {
  isFetching: false,
  items: getLocalStorage(SALES) || [],
  pagination: getLocalStorage(SALES_PAGINATION) || {},
  stats: getLocalStorage(SALES_STATISTIC) || {}
};

export default function(state = STATE, action) {
  switch (action.type) {
    case REQUEST_SALES:
      return {
        ...state,
        isFetching: true
      };

    case RECEIVE_SALES:
      const sales = action.response.data;
      const { pagination, stats } = action.response.meta;

      if (sales) setLocalStorage(SALES, sales);
      if (pagination) setLocalStorage(SALES_PAGINATION, pagination);
      if (stats) setLocalStorage(SALES_STATISTIC, stats);

      return {
        ...state,
        isFetching: false,
        items: sales || state.items,
        pagination: pagination || state.pagination,
        stats: stats || state.stats
      };

    default:
      return state;
  }
}
